/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/

import React from 'react'
import Grid from '@mui/material/Grid'
import { Link } from 'react-router-dom';
import Container from '@mui/material/Container'
import { Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui';



const PageFooter = () => {


  const { classes } = useStyles()
  return (
    <>
      <div className={classes.root}>
        <Container maxWidth="xl" component="footer" >
          <Grid container spacing={4} justify="space-evenly">
          <Grid item xs={12} sm={12} md={2} />

            <Grid item xs={12} sm={6} md={3}>
              <Link
                to={"/"}
              >
                <img src="/assets/images/logo/logo.png" alt="" height="60px" />
              </Link>


            </Grid>
            <Grid item xs={12} sm={6} md={7}>
              <Link to={"/contact-us"} variant="subtitle1"   className={classes.listItemLink} >
                <Typography variant='h4'  color="white"  className={classes.listItemLink} >
                  Contact us
                </Typography>
              </Link>
              <Link to={"/about-us"} variant="subtitle1" color="primary" className={classes.listItemLink} >
                <Typography variant='h4'  color="white"  className={classes.listItemLink} >
                  About us
                </Typography>
              </Link>
              <Link to={"/privacypolicy"} variant="subtitle1" className={classes.listItemLink} >
                <Typography variant='h4' color="white"  className={classes.listItemLink} >
                  Privacy policy
                </Typography>
              </Link>
              <Link to={"/tos"} ariant="subtitle1" className={classes.listItemLink} >
                <Typography variant='h4'  color="white"  className={classes.listItemLink} >
                  Terms of use
                </Typography>
              </Link>
            </Grid>
          </Grid>

        </Container>

      </div>

      <div className={classes.footerdiv}>
        <Typography variant="h4" align="center" color="white"   >
          {'Copyright © '}
          <a target="_blank" rel="noreferrer" href="https://www.Belltane.com" className={classes.listItemLink}>
            Belltane
          </a>{' '}
          {new Date().getFullYear()}
          {'.'} All Rights Reserved.
        </Typography>
      </div>
    </>
  )

}
const useStyles = makeStyles({ "name": { PageFooter } })((theme) => ({
  root: {
    position: "relative",
    background: theme.palette.primary.main,
    paddingTop:"10px",
    color: "white",
    marginTop:'50px',
    paddingBottom: theme.spacing(2),
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      textAlign: 'left',
      paddingLeft: theme.spacing(3),
    },
  },
  footerdiv: {
    background: theme.palette.primary.main,
  },
  text: {
    color: 'white',
  },
  footer: {
    marginTop: '30px',
    marginBottom: '50px!important',


  },
  list: {
    padding: '0'
  },
  listItem: {
    marginBottom: '5px',
    paddingRight: '5px',
    listStyle: 'none!important'

  },
  listItemLink: {
    lineHeight: '25px!important',
    transition: 'all .25s cubic-bezier(.645,.045,.355,1)!important',
    textDecoration: 'none!important',
    listStyle: 'none!important',
    color:'white',
    width: 'fit-content',
    display: 'inline-block',
    marginLeft:'20px',
    marginTop:'16px'
  },
  footerTitle: {
    marginBottom: '17px!important',
    color: 'white'
  },

}));
export default PageFooter;
